<template>
    <div>
      <Search_expire_product/>
    </div>
  </template>
  
  <script>
  import Search_expire_product from "@/components/adminArin/pos_system/warehouse/search_expire_product/Search_expire_product";
  export default {
    name: "searchexpireproduct",
    components: {
        Search_expire_product
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  